import { KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from "@dnd-kit/core";
import { arrayMove, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { useState } from "react";
import { useTemplatePipeline } from "../stores/TemplatePipeline";

export interface UseDragAndDropProps {
    MouseSensor?: {
        activationConstraint?: {
            distance?: number
        }
    }
    TouchSensor?: {
        activationConstraint?: {
            delay?: number,
            tolerance?: number
        }
    }
    initialData?: any[]
}

const useDragAndDropTemplate = (props?: UseDragAndDropProps) => {
    const [updatedData, setUpdatedData] = useState<any[]>(props?.initialData || []);
    const [hasChanges, setHasChanges] = useState(false);
    const [originalOrder, setOriginalOrder] = useState<any[]>(props?.initialData || []);

    const handleDragEnd = (event: any) => {
        const { active, over } = event;
        if (active.id !== over.id) {
            const updateData = (data: any[]) => {
                const oldIndex = data.findIndex(item => item.id === active.id);
                const newIndex = data.findIndex(item => item.id === over.id);
                return arrayMove(data, oldIndex, newIndex);
            }

            const newData = updateData(updatedData);
            setUpdatedData(newData);

            const hasOrderChanged = newData.some((item, index) =>
                originalOrder[index]?.id !== item.id
            );
            setHasChanges(hasOrderChanged);
        }
    }

    const initializeData = (data: any[]) => {
        setUpdatedData(data);
        setOriginalOrder(data);
        setHasChanges(false);
    }

    const cancelChanges = () => {
        setUpdatedData(originalOrder);
        setHasChanges(false);
    }

    const sensors = useSensors(
        useSensor(MouseSensor, {
            activationConstraint: {
                distance: props?.MouseSensor?.activationConstraint?.distance || 10
            }
        }),
        useSensor(TouchSensor, {
            activationConstraint: {
                delay: props?.TouchSensor?.activationConstraint?.delay || 250,
                tolerance: props?.TouchSensor?.activationConstraint?.tolerance || 5
            }
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates
        })
    );

    return {
        updatedData,
        setUpdatedData,
        handleDragEnd,
        sensors,
        hasChanges,
        initializeData,
        cancelChanges
    };
}

export default useDragAndDropTemplate;